import produce, { applyPatches } from 'immer';
import { combineReducers } from 'redux';
import * as TYPES from '../actions/actionTypes';
import config from '../config';
import initialState from '../store/state';

const rootReducer = combineReducers({
    imStore: (state = initialState, action) => {
        if (action.type) {
            if (action.isPatch) {
                // vue mutations
                return applyPatches(state, action.payload);
            } else if (action.type === TYPES.IM_INITIALIZE_SDK) {
                // vue actions
                return produce(state, draft => {
                    console.log(`Received action: [${action.type}]`);
                    Object.assign(draft, action.payload);
                });
            } else {
                // redux actions
                return state;
            }
        } else {
            return state;
        }
    },
    showChat: (showChat = false, action) => {
        if (action.type === TYPES.UI_SHOW_CHAT) {
            return action.payload;
        } else if (action.type === TYPES.UI_CLOSE_CHAT) {
            return false;
        } else {
            return showChat;
        }
    },
    showIM: (showIM = false, action) => {
        if (action.type === TYPES.UI_TOGGLE_IM) {
            if (action.payload !== undefined) {
                return action.payload;
            } else {
                return !showIM;
            }
        } else {
            return showIM;
        }
    },
    customerServiceAccount: (accountId = null, action) => {
        if (action.type === TYPES.DATA_UPDATE_CUSTOMER_SERVICE_ACCOUNT) {
            return action.payload;
        } else {
            return accountId;
        }
    },
    showImageDialog: (showImageDialog = false, action) => {
        if (action.type === TYPES.UI_SHOW_DIALOG) {
            return action.payload;
        } else {
            return showImageDialog;
        }
    },
    imgUrl: (imgUrl = '', action) => {
        if (action.type === TYPES.UI_IMG_URL) {
            return action.payload;
        } else {
            return imgUrl;
        }
    },
    isLocalSession: (isLocalSession = false, action) => {
        //  如果是插入的本地会话，没有加载历史记录
        if (action.type === TYPES.DATA_IS_LOCAL_SESSION) {
            return action.payload;
        } else {
            return isLocalSession;
        }
    },
});

export default { [config.reduxStoreName]: produce(rootReducer) };
